<template>
    <div class="loginModel" v-show="show">
      <div class="loginModel-main">
        <img  class="panda show" src="~@/assets/logo1.png" alt="no img">
        <img  class="panda" src="~@/assets/logo2.png" alt="no img">
        <img  class="panda" src="~@/assets/logo3.png" alt="no img">
        <div class="loginModel-title">
          <h3>登录/注册</h3>
          <a href="javascript:;" @click="close">x</a>
        </div>
        <span style="font-size:12px;">没有注册的用户会自动注册</span>
        <form class="loginModel-form">
          <input @click="loginClick"  @blur="leave" data-show="0" v-model="loginForm.name" type="text" placeholder="用户名" />
          <input @click="loginClick"  @blur="leave" data-show="1" v-model="loginForm.phone" type="number" placeholder="手机号" />
          <input @click="loginClick"  @blur="leave" data-show="2" v-model="loginForm.password" type="password" placeholder="密码（不少于6位）" />
          <button>立即注册</button>
        </form>
        <div class="loginModel-thrid-login">
          <span>第三方登录:</span>
          <a href="javascript:;">
            <img src="~@/assets/xl.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/github.png" alt />
          </a>
          <a href="javascript:;">
            <img src="~@/assets/wx.png" alt />
          </a>
        </div>
      </div>
    </div>
</template>

<script>
 export default {
   name:'bs-login',
   data () {
     return {
       loginForm:{
         name:'',
         phone:'',
         password:''
       },
       show:true
     }
   },
   methods:{
     loginClick(e){
       let panda = document.getElementsByClassName('panda');
       let index = e.target.dataset.show;
       for(let i = 0; i<panda.length; i++){
         panda[i].className = 'panda'
       }
       panda[index].className = 'panda show'
     },
     leave(){
       let panda = document.getElementsByClassName('panda');
       for(let i = 0; i<panda.length; i++){
         panda[i].className = 'panda'
       }
       panda[0].className = 'panda show'
     },
     close(e){
       this.show = false
     }
   },
   components: {

   }
 }
</script>

<style lang="less">
.show{
  display: block !important;
}

.loginModel {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index:9999;
  .loginModel-main {
    position: relative;
    background-color: #fff;
    width: 270px;
    padding: 24px;
    z-index: 9999;
    .panda{
      display: none;
      position: absolute;
      width: 120px;
      height: 110px;
      top: -26%;
      left: 30%;
    }
    .loginModel-title{
      display: flex;
      justify-content: space-between;
    }

    .loginModel-form {
      margin-bottom: 14px;
      input {
        display: block;
        width: 100%;
        line-height: 36px;
        background-color: #fbfbfb;
        border: 1px solid #f4f4f4;
        border-radius: 2px;
        outline: none;
        margin: 10px 0;
        text-indent: 10px;
        &:focus {
        outline:none;
        border: 1px solid #007fff;
        }
      }
      button {
        width: 100%;
        -webkit-appearance: none;
        appearance: none;
        background-color: #007fff;
        color: #fff;
        border-radius: 2px;
        border: none;
        padding: 0.5rem 1.3rem;
        outline: none;
        transition: background-color 0.3s, color 0.3s;
        cursor: pointer;
        &:hover{
          background-color: #4c9cec;
        }
      }
    }
    .loginModel-thrid-login {
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        color: #666;
        margin-right: 10px;
      }
      a {
        margin: 0 10px;
        img {
          display: inline-block;
          height: 20px;
          width: 20px;
        }
      }
    }
  }
}
 
</style>

